import { option_Groups_Title_Text } from './GroupOptions.locstring.json';
import { LazyModule } from 'owa-bundling';
import { isFeatureEnabled } from 'owa-feature-flags';
import { createLazyOption, LazyOption } from 'owa-options-core';
import { isConsumer } from 'owa-session-store';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));

const GroupsOption: LazyOption = createLazyOption(
    {
        key: 'GroupsOption',
        titleStringKey: option_Groups_Title_Text,
        searchTermsStringKey: option_Groups_Title_Text,
        hideTitleInFullOptions: true,
        isHidden: () => isConsumer() || !isFeatureEnabled('grp-echoSuppressionOption'),
    },
    lazyFullModule,
    m => m.default
);

export default GroupsOption;
